module.exports = __webpack_public_path__ + "img/ic-ic-tr-gift.bda26dd9.svg";